<template>
  <div class="question">
    <div class="questionTopWrapper">
      <img v-if="imgsrc" :src="imgsrc" class="cardimg question-img" />
      <h1 class="questionTitle">{{ card.front_word.word }}</h1>
    </div>

    <div class="answersWrapper">
      <div
        class="answer"
        v-for="(selection, selectionindex) in selections"
        :key="`${selection.id}-${selectionindex}-input`"
        @click="selectAnswer(selection)"
      >
        <div class="answerItem" :class="{ selected: selection.id == selected }">
          <i
            class="fas fa-check-circle checkedIcon"
            v-if="selection.id == selected"
          />
          <h3>{{ selection.word }}</h3>
        </div>
      </div>
    </div>
    <div style="margin: 16px; display:flex">
      <van-button
        type="primary"
        block
        @click="submit"
        :disabled="selected == null"
      >
        {{ $t("submit") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    card: {
      type: Object,
      required: true
    },
    selections: {
      type: Array,
      required: true
    }
  },
  computed: {
    imgsrc() {
      return this.getImgSrc();
    }
  },
  data() {
    return { selected: null };
  },
  methods: {
    getImgSrc() {
      const { card } = this;
      const url = card.front_word?.image?.url;
      return url ? `${this.$b2_initial_images}/${url}` : "";
      // return url ? `http://localhost:8080/img/local/${url}` : "";
    },
    selectAnswer({ id }) {
      this.selected = id;
    },
    submit() {
      const isCorrect = this.selected == this.card.back_word.id ? true : false;
      this.$emit("submit", isCorrect);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles.scss";
$font-size-huge: 1rem;
.questionTopWrapper {
  padding-top: 30px;
}
.question {
  .cardimg.question-img {
    margin: auto;
    min-height: 100px;
    max-height: 45vh;
  }
}
.questionTitle {
  text-align: center;
  padding: 30px;
  padding-top: 0;
}
.answersWrapper {
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  .answer {
    position: relative;
    flex: 0 50%;
    text-align: center;

    justify-content: center;
    align-items: center;
    height: 60px;
    display: flex;
    margin-bottom: 10px;

    .answerItem {
      position: relative;
      border: 1px solid #e3e3e3;
      height: 100%;
      width: 100%;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      &.selected {
        border: 2px solid green;
      }
    }

    .checkedIcon {
      color: green;
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
}
</style>
